import { Checkbox, Stack } from '@mantine/core';
import { BasicFieldInputs } from '../components/BasicFieldInputs';
import { useIntl } from 'react-intl';

export const RobeSizesField = ({
  field,
  setField,
}: {
  field: any;
  setField: (field: any) => void;
}) => {
  const intl = useIntl();
  return (
    <Stack gap="md">
      <BasicFieldInputs
        fields={['label']}
        fieldValues={field}
        requiredFields={['label']}
        onChange={(key, value) => setField({ ...field, [key]: value })}
      />

      <Checkbox
        label={intl.formatMessage({ id: 'disabled' })}
        value={field.isDisabled}
        onChange={(event) =>
          setField({ ...field, isDisabled: event.currentTarget.checked })
        }
      />
    </Stack>
  );
};
